import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { jsx, jsxs } from 'react/jsx-runtime.js';
import React__default from 'react';
import cn from 'classnames';
import { ReactComponent as SvgWarning } from '../../media/images/warning.svg.js';
import styles from './ProjectAuditTabs.module.css.js';

var TabsTypeEnum;
(function (TabsTypeEnum) {
  TabsTypeEnum["vertical"] = "Vertical";
  TabsTypeEnum["horizontal"] = "Horizontal";
})(TabsTypeEnum || (TabsTypeEnum = {}));
var TabsSizeEnum;
(function (TabsSizeEnum) {
  TabsSizeEnum["small"] = "small";
  TabsSizeEnum["normal"] = "normal";
})(TabsSizeEnum || (TabsSizeEnum = {}));
var ProjectAuditTabs = /*#__PURE__*/React__default.memo(function (props) {
  var _cn;
  var options = props.options,
    selected = props.selected,
    onSelectTab = props.onSelectTab,
    className = props.className,
    tabsListClassName = props.tabsListClassName,
    tabClassName = props.tabClassName,
    tabSelectedClassName = props.tabSelectedClassName,
    tabContentClassName = props.tabContentClassName,
    type = props.type,
    _props$size = props.size,
    size = _props$size === void 0 ? TabsSizeEnum.normal : _props$size;
  var onClick = function onClick(e) {
    var _e$currentTarget$getA;
    onSelectTab((_e$currentTarget$getA = e.currentTarget.getAttribute('data-id')) !== null && _e$currentTarget$getA !== void 0 ? _e$currentTarget$getA : '');
  };
  return jsx("div", {
    className: cn(styles.blockContainer, className),
    children: jsx("ul", {
      "data-qd-test": props['data-qd-test'],
      className: cn(styles.list, tabsListClassName, (_cn = {}, _defineProperty(_cn, styles.single, options.length === 1), _defineProperty(_cn, styles.horizontal, type === TabsTypeEnum.horizontal), _defineProperty(_cn, styles.small, size === TabsSizeEnum.small), _cn)),
      children: options.map(function (_ref) {
        var _cn2;
        var count = _ref.count,
          id = _ref.id,
          showingWarning = _ref.showingWarning,
          title = _ref.title,
          qdTest = _ref['data-qd-test'];
        return jsx("li", {
          "data-qd-test": qdTest,
          children: jsx("button", {
            "data-id": id,
            className: cn(styles.button, tabClassName, (_cn2 = {}, _defineProperty(_cn2, styles.warning, showingWarning), _defineProperty(_cn2, styles.selected, selected === id), _cn2), !!tabSelectedClassName ? _defineProperty({}, tabSelectedClassName, selected === id) : ''),
            onClick: onClick,
            children: jsxs("span", {
              className: cn(styles.content, tabContentClassName),
              tabIndex: -1,
              children: [title, " ", jsx("span", {
                className: styles.count,
                children: count
              }), showingWarning && jsx(SvgWarning, {
                className: styles.icon
              })]
            })
          }, id)
        }, id);
      })
    })
  });
});

export { ProjectAuditTabs, TabsSizeEnum, TabsTypeEnum };
